import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldCode"><Path fillRule="evenodd" clipRule="evenodd" d="M21 5.25391V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.25391L12 1.43555L21 5.25391ZM6.68945 12L10 15.3105L11.0605 14.25L8.81055 12L11.0605 9.75L10 8.68945L6.68945 12ZM12.9395 9.75L15.1895 12L12.9395 14.25L14 15.3105L17.3105 12L14 8.68945L12.9395 9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCode;
